import { Content } from '../../types';

export const bangkokTransportationContent: Content = {
  title: 'התחבורה הציבורית בבנגקוק - המדריך השלם',
  imageUrl:
    '/images/thailand/bangkok-transportation/bangkok-transportation-wide.jpeg',
  introduction: `בנגקוק, בירת תאילנד, הינה אחת הערים העמוסות והתוססות בעולם, המאכלסת כעשרה מיליון תושבים ומיליוני תיירים נוספים בכל רגע נתון. בהתאם לכך, התחבורה הציבורית בעיר מגוונת, עניפה ולעיתים אף מאתגרת להתמצאות למי שאינו מקומי. עם זאת, הבנה בסיסית של אפשרויות התחבורה הקיימות יכולה לשדרג משמעותית את חוויית הטיול בעיר ולסייע בחיסכון בזמן ובכסף.`,
  sections: [
    {
      title: 'מערכת הרכבות - הדרך הנוחה והמהירה ביותר',
      content:
        'גולת הכותרת של התחבורה הציבורית בבנגקוק הינה מערכת הרכבות המהירות, הכוללת רכבות עיליות (BTS Skytrain), רכבת תחתית (MRT), ורכבת עילית לשדה התעופה (Airport Rail Link).',
      type: 'text',
    },
    {
      title: 'קווי הרכבת העילית - BTS Skytrain',
      type: 'sub-headers',
      description:
        'מערכת הרכבות העיליות של בנגקוק מחולקת לשני קווים ראשיים ולמספר קווים משלימים:',
      content: [
        {
          subtitle: 'קו סוקומוויט (Sukhumvit Line - הקו הירוק בהיר)',
          text: 'מחבר בין אזורי העסקים, הקניות והמלונות המרכזיים. תחנות חשובות: Mo Chit - שוק סוף השבוע Siam , Chatuchak - אזור הקניות המרכזי בבנגקוק, Asok - מפגש עם רכבת תחתית, Phrom Phong - אזור הקניונים Emporium ו-EmQuartier , On Nut - אזור מגורים זול יותר לתיירים, Bearing - קצה הקו בדרום מזרח העיר. לאחרונה הורחב הקו דרומה עד Kheha, כולל עצירות באזור Samut Prakan ומוזיאון האמנות העתיקה Erawan.',
        },
        {
          subtitle: 'קו סילום (Silom Line - הקו הירוק כהה)',
          text: 'מחבר בין אזורי העסקים סילום וסאטורן לאזור נהר הצ׳או פראיה. תחנות חשובות: National Stadium - ליד MBK ומגרש האגרוף לומפיני, Sala Daeng - מפגש עם ה-MRT באזור חיי הלילה של Patpong, Saphan Taksin - תחנת מעבר לסירות הנהר, Bang Wa - קצה הקו ממערב לנהר.',
        },
        {
          subtitle: 'קווים משלימים של ה-BTS',
          text: 'קו גולד ליין (Gold Line) - מקשר בין BTS סאפאן טאקסין לקניון ICONSIAM ולתחנת Khlong San. קו עתידי MRT Pink Line - רכבת מונורייל שתשמש כאמצעי תחבורה נוסף לפרברים המזרחיים.',
        },
      ],
    },
    {
      title: 'BTS Skytrain',
      content: '',
      type: 'image',
      imageUrl:
        '/images/thailand/bangkok-transportation/bangkok-transportation-article-1.jpeg',
    },
    {
      title: 'רכבת עילית לשדה התעופה (Airport Rail Link)',
      content:
        'הרכבת העילית לשדה התעופה, מחברת בין שדה התעופה הבינלאומי והמרכזי של בנגקוק Suvarnabhumi לתחנת Phaya Thai אשר בה יש גם תחנה של הרכבת העילית ה - BTS קו Sukhumvit. הרכבת פעילה בין השעות 05:30 ל - 24:00 והנסיעה בין שתי תחנות הקצה אורכת כ - 25 דקות בלבד, משמע זהו הפתרון האולטימטיבי לתנועה בין שדה התעופה לבין מרכז העיר והאזורים המכוסים ע"י קווי הרכבת העילית, שכן ניתן לעבור לקווים אלו בתחנת Phaya Thai.',
      type: 'text',
    },
    {
      title: 'הרכבת התחתית MRT',
      type: 'sub-headers',
      description:
        'בניגוד ל-BTS שנעה בעיקר לאורך צירים מרכזיים עיליים, ה-MRT היא רכבת תחתית החוצה את העיר במסלולים נוספים:',
      content: [
        {
          subtitle: 'הקו הכחול (Blue Line)',
          text: 'קו מעגלי מרכזי המחבר בין אזורי תיירות ושכונות מרכזיות. תחנות חשובות: Hua Lamphong - תחנת הרכבת המרכזית, Wat Mangkon - צ׳יינה טאון, Sam Yot - בקרבה לקוואסאן, Sukhumvit - מפגש עם BTS Asok, Chatuchak Park - ליד שוק סוף השבוע. לאחרונה נסגרה תחנת Hua Lamphong כתחנה סופית, והקו הכחול הפך למעגלי, מה שמאפשר תנועה רציפה ללא צורך בהחלפת רכבות.',
        },
        {
          subtitle: 'הקו הסגול (Purple Line)',
          text: 'קו מקשר בין בנגקוק לפרברים הצפוניים (נונטבורי). פחות רלוונטי לתיירים, אך כולל חיבור ל-MRT הכחול בתחנת Tao Poon.',
        },
        {
          subtitle: 'קווים חדשים ומורחבים',
          text: 'MRT הצהוב Yellow Line - רכבת מונורייל חדשה - מחברת בין אזור Lat Phrao והפרברים המזרחיים של בנגקוק. MRT הוורוד (Pink Line - רכבת מונורייל בתכנון) - תחבר את אזור צפון מזרח בנגקוק עם המרכז.',
        },
      ],
    },
    {
      title: 'תחבורה יבשתית',
      type: 'sub-headers',
      description:
        'מלבד מערכות הרכבות, בנגקוק מציעה מגוון אמצעי תחבורה יבשתיים לניידות בתוך העיר:',
      content: [
        {
          subtitle: 'מוניות ומוניות-אופנוע',
          text: 'מוניות רגילות - מומלץ להשתמש באפליקציות Grab ו-Bolt כדי לקבל מחיר הוגן מראש ולמנוע ויכוחים עם נהגים. מוניות-אופנוע - פתרון יעיל במיוחד לאנשים יחידים הזקוקים לתנועה מהירה בתוך העיר, בעיקר בשעות העומס.',
        },
        {
          subtitle: 'טוקטוקים',
          text: 'חוויה תיירותית אך יקרה! הטוקטוקים הפכו לאחד הסמלים המזוהים עם בנגקוק, אך לרוב הם יקרים יותר ממוניות ולא תמיד נוחים. הם מומלצים בעיקר לחוויית נסיעה אותנטית ולא כאמצעי תחבורה יומיומי.',
        },
        {
          subtitle: 'אוטובוסים',
          text: 'מערכת האוטובוסים של בנגקוק רחבה וזולה מאוד, אך אינה נוחה לתיירים בשל מחסור בשילוט הסברה באנגלית. ישנם אוטובוסים עם מיזוג אוויר (צבועים לרוב בכחול-לבן) ואוטובוסים ישנים וזולים ללא מיזוג.',
        },
      ],
    },
    {
      title: 'תחבורה ימית',
      type: 'sub-headers',
      description:
        'בנגקוק מציעה פתרונות תחבורה ימיים מצוינים שיכולים לחסוך זמן רב ולעקוף את הפקקים הידועים בעיר:',
      content: [
        {
          subtitle: 'סירות הנהר - Chao Phraya Express',
          text: 'פועלות לאורך נהר הצ׳או פראיה ועוברות דרך אתרים מרכזיים כמו ארמון המלך, וואט ארון, צ׳יינה טאון ואזור הקניות ICONSIAM. מומלץ להשתמש בסירות הכתומות, שהן הפופולריות ביותר בקרב מקומיים ותיירים או בסירות התיירים Chao Phraya Tourist Boat.',
        },
        {
          subtitle: 'סירות התעלות - Khlong Boats',
          text: 'פתרון מצוין למי שרוצה להימנע מפקקים במרכז העיר. קו חשוב עובר מאזור פראטונם לרציף Panfa הסמוך לרחוב הקוואסאן. יש לזכור שהסירות אינן פעילות בשעות הלילה ובימי ראשון.',
        },
      ],
    },
    {
      title: 'סירת תיירים בנהר הצ׳או פראיה',
      content: '',
      type: 'image',
      imageUrl:
        '/images/thailand/bangkok-transportation/bangkok-transportation-article-2.jpeg',
    },
    {
      title: 'טיפים חשובים',
      type: 'sub-headers',
      description: 'המלצות שימושיות להתמצאות וניידות יעילה בבנגקוק:',
      content: [
        {
          subtitle: 'תכנון נסיעות',
          text: 'Google Maps הוא החבר הכי טוב שלכם - הוא מכיל מסלולי אוטובוסים, רכבות, וסירות, השתמשו בו לפני כל נסיעה! השתמשו במערכת הרכבות כבסיס לתנועה בעיר. השימוש ברכבות ובכלל זה אופן קניית הכרטיסים, הינו יעיל, ידידותי ופשוט מאוד.',
        },
        {
          subtitle: 'כרטיסים וחסכון',
          text: 'ניתן לרכוש כרטיס חופשי יומי לרכבות העיליות (לא כולל Airport Link) בעלות של 150 באט. הימנעו ממוניות ללא מונה - תמיד עדיף להשתמש ב-Grab/Bolt. לנסיעות קצרות - העדיפו מונית-אופנוע או טוקטוק (אם המחיר הגיוני).',
        },
        {
          subtitle: 'הגעה ליעדים פופולריים',
          text: 'עבור הגעה לשוק צ׳אטוצ׳אק (שוק סופ"ש), השתמשו ברכבות העילית ו/או התחתית. עבור הגעה לקניון ICON SIAM, השתמשו ברכבות העיליות (קווי סילום + גולד ליין) או בסירות הנהר). לנסיעות בין אזור הקוואסאן למרכז העיר, בשעות היום, השתמשו בסירות התעלה, במסלול פראטונם - Panfa, זו הדרך המהירה ביותר!',
        },
        {
          subtitle: 'נסיעות לשדה התעופה',
          text: 'עבור נסיעות אל/משדה התעופה Suvarnabhumi, השתדלו להשתמש בקו הרכבת העילית הייעודי, הוא זול (45 באט בלבד) ומהיר (25 דקות בלבד).',
        },
        {
          subtitle: 'שכירת רכב',
          text: 'עבור שהות בעיר עצמה בלבד - אף פעם לא לשכור רכב, עבור טיולים מחוץ לעיר - מומלץ מאוד לשכור רכב.',
        },
      ],
    },
    {
      title: 'מפת BTS Skytrain',
      content: '',
      type: 'image',
      imageUrl:
        '/images/thailand/bangkok-transportation/bangkok-transportation-article-3.jpeg',
    },
    {
      title: 'בשורה התחתונה',
      content:
        'בנגקוק מציעה שפע של אפשרויות תחבורה וכשמשלבים אותן נכון, ניתן להתנייד בעיר בקלות, במהירות וללא פקקים! הדרך היעילה ביותר להתנייד הינה שילוב בין אמצעי התחבורה השונים, תוך התחשבות בעומסי התנועה ובכיסוי של כל אמצעי תחבורה.',
      type: 'text',
      isBold: true,
    },
  ],
};
